var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page flex-col"},[_c('div',{staticClass:"block_9 flex-row"},[_c('div',{staticClass:"box_63 flex-col"},[_c('PageHeader'),_c('div',{staticClass:"sub-page-content",domProps:{"innerHTML":_vm._s(_vm.content)}}),_c('PageFooter')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }